__webpack_require__.p = "/your-hot-job/";